var _path, _g, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutCode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#f8b775",
    width: 64,
    height: 64,
    viewBox: "-64 -64 384 384",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 273.971c21.386.014 35.91-22.69 56.367-28.925 24.837-7.57 54.016 2.279 76.064-11.435 22.851-14.214 38.757-38.996 46.467-64.779 7.838-26.216 7.12-55.536-2.875-81.008-9.673-24.649-33.183-40.094-51.968-58.755-17.071-16.957-31.786-37.295-54.01-46.518-21.894-9.086-46.553-8.13-70.045-4.966C106.067-19.461 88.066-4.65 66.49.272 38.241 6.715-.195-11.284-18.663 11.04c-18.306 22.129 12.969 56.992 6.04 84.863-7.127 28.664-49.501 45.331-45.692 74.621 3.66 28.152 38.052 41.955 62.687 56.065 20.434 11.704 45.306 9.957 67.295 18.384 19.97 7.654 34.945 28.984 56.332 28.997",
    fill: "#f8b77521"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.56 91.073 22.249 128l44.313 36.927a4 4 0 0 1-5.122 6.146l-48-40a4 4 0 0 1 0-6.146l48-40a4 4 0 0 1 5.122 6.146Zm176 33.854-48-40a4 4 0 0 0-5.12 6.146L233.751 128l-44.313 36.927a4 4 0 0 0 5.122 6.146l48-40a4 4 0 0 0 0-6.146ZM161.368 36.24a3.998 3.998 0 0 0-5.126 2.392l-64 176a4 4 0 1 0 7.518 2.734l64-176a4 4 0 0 0-2.392-5.126Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutCode);
export default __webpack_public_path__ + "static/media/AboutCode.d8c6be9be53ff04c6e5007f3cb714257.svg";
export { ForwardRef as ReactComponent };